import PrimaryButton from "components/buttons/primary-button";
import Typography from "components/typography";
import React, { useRef, useState } from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import { FormatAudioDuration } from "utils/numberConvert";

interface IProps {
  handleSeek: (value: number) => void;
  GoToTime: (value: number) => void;
  duration?: number;
  currentTime?: number;
  togglePlay?: () => void;
  isPlaying?: boolean;
  slowDown: (isSlow: boolean) => void;
  save: () => void;
  loading: boolean;
}
const Player = ({
  handleSeek,
  GoToTime,
  duration = 0,
  currentTime = 0,
  togglePlay,
  isPlaying,
  slowDown,
  save,
  loading
}: IProps) => {
  const [isSlow, setIsSlow] = useState(false);

  const SlowAudio = () => {
    setIsSlow(!isSlow);
    slowDown(isSlow);
  };
  return (
    <Container>
      <RangeContainer>
        <TogglePlayButton onClick={togglePlay}>
          {isPlaying ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 20 21"
              fill="none"
            >
              <path
                d="M1.66602 5.49984C1.66602 3.92849 1.66602 3.14281 2.15417 2.65466C2.64232 2.1665 3.428 2.1665 4.99935 2.1665C6.5707 2.1665 7.35637 2.1665 7.84452 2.65466C8.33268 3.14281 8.33268 3.92849 8.33268 5.49984V15.4998C8.33268 17.0712 8.33268 17.8568 7.84452 18.345C7.35637 18.8332 6.5707 18.8332 4.99935 18.8332C3.428 18.8332 2.64232 18.8332 2.15417 18.345C1.66602 17.8568 1.66602 17.0712 1.66602 15.4998V5.49984Z"
                fill="white"
              />
              <path
                d="M11.666 5.49984C11.666 3.92849 11.666 3.14281 12.1542 2.65466C12.6423 2.1665 13.428 2.1665 14.9993 2.1665C16.5707 2.1665 17.3563 2.1665 17.8445 2.65466C18.3327 3.14281 18.3327 3.92849 18.3327 5.49984V15.4998C18.3327 17.0712 18.3327 17.8568 17.8445 18.345C17.3563 18.8332 16.5707 18.8332 14.9993 18.8332C13.428 18.8332 12.6423 18.8332 12.1542 18.345C11.666 17.8568 11.666 17.0712 11.666 15.4998V5.49984Z"
                fill="white"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M14.2718 6.23497C15.6864 7.00425 15.6864 8.99559 14.2718 9.76485L5.73043 14.4096C4.35558 15.1573 2.66602 14.1841 2.66602 12.6447V3.35519C2.66602 1.81571 4.35558 0.842598 5.73042 1.59024L14.2718 6.23497Z"
                fill="white"
              />
            </svg>
          )}
        </TogglePlayButton>
        <Typography mr="1.2">
          {FormatAudioDuration(currentTime || 0)}
        </Typography>
        <Range
          min="0"
          max={"100"}
          value={(Number(currentTime) / duration) * 100}
          onChange={(e) => {
            handleSeek(Number(e.target.value));
          }}
        />
        <Typography ml="1.2">{FormatAudioDuration(duration)}</Typography>
      </RangeContainer>
      <Buttons>
        <AudioChangeButton onClick={() => GoToTime(currentTime - 5)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M11.668 3.74984L10.0013 1.6665C14.6036 1.6665 18.3346 5.39746 18.3346 9.99984C18.3346 14.6022 14.6036 18.3332 10.0013 18.3332C5.39893 18.3332 1.66797 14.6022 1.66797 9.99984C1.66797 6.58264 3.72479 3.64584 6.66797 2.35991"
              stroke="currentColor"
              stroke-width="1.25"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.6654 7.0835H9.4657C9.28636 7.0835 9.12711 7.19826 9.07036 7.3684L8.51486 9.03508C8.42486 9.30491 8.6257 9.5835 8.91011 9.5835H9.9987C10.9192 9.5835 11.6654 10.3297 11.6654 11.2502C11.6654 12.1707 10.9192 12.9168 9.9987 12.9168H8.33203"
              stroke="currentColor"
              stroke-width="1.25"
              stroke-linecap="round"
            />
          </svg>
        </AudioChangeButton>
        <AudioChangeButton onClick={() => GoToTime(currentTime + 5)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M8.33464 3.74984L10.0013 1.6665C5.39893 1.6665 1.66797 5.39746 1.66797 9.99984C1.66797 14.6022 5.39893 18.3332 10.0013 18.3332C14.6036 18.3332 18.3346 14.6022 18.3346 9.99984C18.3346 6.58264 16.2778 3.64584 13.3346 2.35991"
              stroke="currentColor"
              stroke-width="1.25"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.6654 7.0835H9.4657C9.28636 7.0835 9.12711 7.19826 9.07036 7.3684L8.51486 9.03508C8.42486 9.30491 8.6257 9.5835 8.91011 9.5835H9.9987C10.9192 9.5835 11.6654 10.3297 11.6654 11.2502C11.6654 12.1707 10.9192 12.9168 9.9987 12.9168H8.33203"
              stroke="currentColor"
              stroke-width="1.25"
              stroke-linecap="round"
            />
          </svg>
        </AudioChangeButton>
        <AudioChangeButton
          onClick={SlowAudio}
          style={{ color: isSlow ? Colors.yellow500 : "" }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M2.66406 10.1668C2.66406 10.8234 2.79339 11.4736 3.04466 12.0802C3.29594 12.6869 3.66424 13.2381 4.12853 13.7024C4.59282 14.1667 5.14402 14.535 5.75065 14.7862C6.35727 15.0375 7.00745 15.1668 7.66406 15.1668C8.32067 15.1668 8.97085 15.0375 9.57748 14.7862C10.1841 14.535 10.7353 14.1667 11.1996 13.7024C11.6639 13.2381 12.0322 12.6869 12.2835 12.0802C12.5347 11.4736 12.6641 10.8234 12.6641 10.1668C12.6641 9.28277 12.3129 8.43493 11.6878 7.80981C11.0626 7.18469 10.2148 6.8335 9.33073 6.8335C8.44667 6.8335 7.59883 7.18469 6.97371 7.80981C6.34859 8.43493 5.9974 9.28277 5.9974 10.1668C5.9974 10.6089 6.17299 11.0328 6.48555 11.3453C6.79811 11.6579 7.22203 11.8335 7.66406 11.8335C8.10609 11.8335 8.53001 11.6579 8.84257 11.3453C9.15513 11.0328 9.33073 10.6089 9.33073 10.1668"
              stroke="currentColor"
              stroke-width="1.25"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M9.33073 16.8333C13.0126 16.8333 15.9974 13.8486 15.9974 10.1667C15.9974 6.48477 13.0126 3.5 9.33073 3.5C5.64883 3.5 2.66406 6.48477 2.66406 10.1667C2.66406 13.8486 5.64883 16.8333 9.33073 16.8333Z"
              stroke="currentColor"
              stroke-width="1.25"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M2 16.8335H9.81909C11.3199 16.8335 14 15.8335 15.5 12.3335C16.603 9.75989 16 4.5 18 3"
              stroke="currentColor"
              stroke-width="1.25"
              stroke-linecap="round"
            />
          </svg>
        </AudioChangeButton>
      </Buttons>
      <SaveButton>
        <PrimaryButton
          text="Save"
          onClick={save}
          disabled={loading}
          loading={loading}
        />
      </SaveButton>
    </Container>
  );
};

export default Player;

const Container = styled.div`
  width: 100%;
  background-color: ${Colors.grey700};
  padding: 1.4rem 6.4rem;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  position: relative;
  @media only screen and (max-width: 769px) {
    padding: 1rem 2rem;
    padding-top: 6rem;
    justify-content: space-between;
  }
`;

const RangeContainer = styled.div`
  display: flex;
  width: 75%;
  align-items: center;
  @media only screen and (max-width: 769px) {
    width: 80%;
  }
`;

const Range = styled.input.attrs({ type: "range" })`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 100%;
  border-radius: 1rem;
  height: 0.8rem;
  -webkit-transition: 0.2s;
  background: ${(props) => `linear-gradient(
    to right,
    ${Colors.yellow400} ${props.value}%,
    #D9D9D9 ${props.value}%)`};

  transition: background 450ms ease-in;

  &::-webkit-slider-thumb {
    appearance: none;
    width: 1.2rem;
    height: 1.2rem;
    background: white;
    cursor: pointer;
    border-radius: 50%;
  }

  &::-moz-range-thumb {
    width: 1.2rem;
    height: 1.2rem;
    background: white;
    cursor: pointer;
    border-radius: 50%;
  }

  &::-moz-range-progress {
    background-color: #d9d9d9;
  }
`;

const TogglePlayButton = styled.div`
  cursor: pointer;
  width: 2rem;
  height: 2rem;
  margin-right: 1.6rem;
`;

const Buttons = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  grid-column-gap: 1.6rem;
  @media only screen and (max-width: 769px) {
    position: absolute;
    top: 1rem;
    right: 2rem;
  }
`;

const AudioChangeButton = styled.div`
  width: 2rem;
  height: 2rem;
  cursor: pointer;
  transition: all ease-in-out 0.2s;

  &:hover {
    color: ${Colors.yellow100};
  }

  &:active {
    color: ${Colors.yellow500};
  }

  @media only screen and (max-width: 769px) {
    width: 2.5rem;
    height: 2.5rem;
  }
`;

const SaveButton = styled.div`
  width: 10rem;

  @media only screen and (max-width: 769px) {
    width: 6rem;
  }
`;
